import { cn } from '@/lib'
import { ChevronDown } from 'lucide-react'
import { forwardRef } from 'react'
import {
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
	Select as UISelect,
} from '../ui/select'
import { Label } from './Label'

interface Props extends React.ComponentPropsWithRef<typeof UISelect> {
	items: { value: string; label: React.ReactNode; isLabel?: boolean }[]
	label?: React.ReactNode
	placeholder?: React.ReactNode
	error?: React.ReactNode
	triggerClassName?: string
	id?: string
}
/**
 * **Warning:** No forward ref possible, use `Controller` from react-hook-form instead
 */
export const Select = forwardRef<React.ComponentRef<typeof UISelect>, Props>(
	({ items, placeholder, label, error, triggerClassName, ...props }, ref) => {
		return (
			<div className="flex flex-col gap-1 relative">
				<UISelect {...props}>
					{label && <Label className="mb-1">{label}</Label>}
					<SelectTrigger
						className={cn(
							'text-lg rounded-sm border py-[10px] pl-3 pr-2 font-medium outline-hidden h-full',
							error ? 'border-red-500' : '',
							triggerClassName,
						)}
						triggerIcon={<ChevronDown className="ml-1 size-6" />}
					>
						<SelectValue
							placeholder={<span className="font-normal">{placeholder}</span>}
						/>
					</SelectTrigger>
					<SelectContent className="rounded-xs border py-3 px-5">
						<SelectGroup>
							{items.map((item) =>
								item.isLabel ? (
									<SelectLabel key={item.value}>{item.label}</SelectLabel>
								) : (
									<SelectItem
										key={item.value}
										value={item.value}
										className="hover:bg-orange-50 cursor-pointer data-[state=checked]:bg-purple-25 text-lg"
									>
										{item.label}
									</SelectItem>
								),
							)}
						</SelectGroup>
					</SelectContent>
				</UISelect>
				{error && <p className="text-red-500 text-sm">{error}</p>}
			</div>
		)
	},
)
